module.exports = __webpack_public_path__ + "img/img1.7aecb9c7.png";